import { Search, VisibilityRounded,CloseRounded as CloseIcon, Delete } from "@mui/icons-material";
import { Autocomplete, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { CustomAutoComplete, InputWithLabel, SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType, FormActions, FormatPrice, TiposEntregaCheck, sortFunctions } from "../../utils/constants";
import { ModalFormGenerador } from "../../components/form/ModalForm";
import * as yup from "yup";


const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};


const schema = yup.object({
  es_cda: yup.string().required(),
  consolida_por_municipio: yup.string().required(),
  ind_central_institucional: yup.string().required(),
  cod_erp_tipo_docto_fe: yup.string().min(2).max(4).required(),
  ind_permite_recogida: yup.string().required(),
 
}).required();

const schemaServicios = yup.object({
  descripcion: yup.string().required(),
  valor: yup.number().min(0).max(100).required(),
  valor_maximo: yup.number().min(0).required(),
 }).required();



const YesNoQuestion = [
  {
    label:"SI",
    value:"SI"
  },
  {
    label:"NO",
    value:"NO"
  }
]


const ConfiguracionServiciosListItem  = ({
  onDeleteIcon,
  descripcion,
  valor,
  valor_maximo

})=>{

  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" >{TiposEntregaCheck[descripcion] || descripcion}</Typography> 
          <Typography>costo por KG: {valor}</Typography>
          <Typography>Valor maximo: {FormatPrice(valor_maximo)}</Typography>
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}


export const MaestroCentrosOperacion = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [sortQuery,setSortQuery] = useState({});


    useEffect(()=>{

      loadProducts();


    },[]);

    useEffect(()=>{

      if ( Object.keys(sortQuery).length > 0 ){
        console.log({sortQuery});
        let sortedItems = [];
        if (sortQuery.dataType === 'string'){
          sortedItems  = [...sortFunctions.sortString(dataSetProdctos,sortQuery.key,sortQuery.sortValue)];
        }else{
          sortedItems  = [...sortFunctions.sortNumber(dataSetProdctos,sortQuery.key,sortQuery.sortValue)];
        }
        setDataSetProductos(sortedItems);
      }
     

    },[sortQuery]);

    useEffect(()=>{
      setSortQuery({});
      loadProducts( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);
    const loadProducts =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/obtener-centros-operacion-paginacion",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
      
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...filterSearchPagination,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      setProductoSeleccionado(product || {});
    }
    const onCloseModalDetalle = ()=>{
      setIsVisibleModalDetalle(false);
    }
    const setSortLabel = (key,dataType)=>{
       setSortQuery({
        key:key,
        sortValue:sortQuery.key === key?(sortQuery.sortValue === 'ASC'?'DESC':"ASC"):"ASC",
        dataType
       });
    }
    
    const SortLabelRender =  props=> <TableSortLabel
    active={ sortQuery.key === props.keyValue  }
    onClick={e=>setSortLabel( props.keyValue,props.typeRow )}
    direction={(sortQuery.key === props.keyValue? sortQuery.sortValue:'').toLowerCase() }
    >{props.label}</TableSortLabel>;
  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:SortLabelRender,
       bodyRender:(props)=>props.value,
       typeRow:"number",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"CODIGO ERP",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"Nombre",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"es_cda",
        keyValue:"es_cda",
        label:"¿Es CDA?",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"ind_central_institucional",
        keyValue:"ind_central_institucional",
        label:"¿Es Institucional?",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"cod_erp_lista_precios",
        keyValue:"cod_erp_lista_precios",
        label:"COD ERP lista de precios",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"mun_nombre",
        keyValue:"mun_nombre",
        label:"Municipio",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"estado",
        keyValue:"ind_estado",
        label:"Estado",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       
       {
      
        key:"cod",
        keyValue:"cod",
        label:"Ver detalle",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<VisibilityRounded/>} >Ver</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       }, 
    ];

    const onSaveDataFormExterno = async(typeAction,dataForm)=>{
      const payload ={
        ...dataForm,
        servicios:dataForm.servicios?.map(serv_item=>({
          ...serv_item,
          descripcion:TiposEntregaCheck[serv_item.descripcion] || serv_item.descripcion,
          descripcion_corta: TiposEntregaCheck[serv_item.descripcion]? serv_item.descripcion:serv_item.descripcion_corta
        }))
      }
      console.log({
        payload
      });
      
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });

      AxiosInstance.post("maestros/modificar-centro-operacion",payload).then(async res=>{
        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Configuracion actualizada",
              message:"Se ha guardado la informacion de la configuracion",
              type:DialogType.exitoso,
              isVisible:true
          }
      });
       await loadProducts(true);
      })
      .catch(err=>{
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Error de comunicacion verifique su conexion a internet",
              type:DialogType.peligro,
              isVisible:true
          }
      });
      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      }); 

    }

    const configCentroOperacion =  {
      titleModal: "Configurar centro de operacion",
      buttomsAction: [
         
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"descripcion",
          keyValue:"descripcion",
          label:"Centro de operacion",
          component:InputWithLabel,
          inputProps:{
            disabled:true,
            type:"text",
            size:"small",
            
          }
        },
        {
          key:"mun_nombre",
          keyValue:"mun_nombre",
          label:"Ubicacion",
          component:InputWithLabel,
          inputProps:{
            disabled:true,
            type:"text",
            size:"small",
          
          }
        },
        {
          key:"consolida_por_municipio",
          keyValue:"consolida_por_municipio",
          label:"¿Consolida por municipio?",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:YesNoQuestion
          }
        },
        {
          key:"es_cda",
          keyValue:"es_cda",
          label:"¿Es CDA?",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:YesNoQuestion
          }
        },
        {
          key:"ind_central_institucional",
          keyValue:"ind_central_institucional",
          label:"¿Es Central institucional?",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:YesNoQuestion
          }
        },
        
        {
          key:"cod_erp_tipo_docto_fe",
          keyValue:"cod_erp_tipo_docto_fe",
          label:"COD ERP TIPO FACT",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
           
          }
        },
        {
          key:"direccion",
          keyValue:"direccion",
          label:"Direccion",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
          }
        },
        {
          key:"cod_erp_lista_precios",
          keyValue:"cod_erp_lista_precios",
          label:"Codigo ERP LISTA",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
          }
        },
        {
          key:"latitud",
          keyValue:"latitud",
          label:"Latitud",
          responsiveSize:6,
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:YesNoQuestion
          }
        },
        {
          key:"longitud",
          keyValue:"longitud",
          label:"Longitud",
          responsiveSize:6,
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:YesNoQuestion
          }
        },
        
      ],
      arrayInputs:[
        
        {
          label:"Configuracion de servicios",
          key:"servicios",
          keyValue:"servicios",
          subSchema:schemaServicios,
          ItemRender:ConfiguracionServiciosListItem,
          inputs:[
            {
              responsiveSize:12,
              key:"descripcion",
              keyValue:"descripcion",
              label:"Tipo de entrega",
              component:SelectInputWithLabel,
              
              inputProps:{
                type:"text",
                size:"small",
                items:Object.keys(TiposEntregaCheck).map(key=>({label:TiposEntregaCheck[key],value:key})),
              }
            },
            {
            
              key:"valor",
              keyValue:"valor",
              label:"Costo por Kg (Valor)",
              component:InputWithLabel,
              inputProps:{
                type:"number",
                size:"small",
              }
            },
            {
              key:"valor_maximo",
              keyValue:"valor_maximo",
              label:"Valor maximo del servicio",
              component:InputWithLabel,
              inputProps:{
                type:"number",
                size:"small",
              }
            },
            
          ]
        }
      ]
    };

    return (<>
     {
      isVisibleModalDetalle &&
      <ModalFormGenerador
        isVisible={isVisibleModalDetalle}
        schemaValidator={schema}
        entityValues={productoSeleccionado}
        {
        ...configCentroOperacion
        }
        onSendForm={onSaveDataFormExterno}
        typeAction={FormActions.MODIFICAR}
      />
    } 
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar centro de operacion"
              inputType="text"
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender {...colum} label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}